"use client";
import { jsx as a } from "react/jsx-runtime";
import { memo as o } from "react";
import h from "../components/Icon/SvgIcon.js";
const e = (l) => /* @__PURE__ */ a(
  h,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...l,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.473 3.805c.26-.346.668-.55 1.1-.55h2.9c.433 0 .841.204 1.1.55l.776 1.034h-6.65zM7.16 4.839a.6.6 0 0 1 .077-.134l1.237-1.65a2.63 2.63 0 0 1 2.1-1.05h2.9c.827 0 1.605.389 2.1 1.05l1.238 1.65a.6.6 0 0 1 .077.134h2.486v.005h.575a.625.625 0 1 1 0 1.25h-.665l-1.002 14.038a2 2 0 0 1-1.995 1.858H7.76a2 2 0 0 1-1.994-1.857L4.763 6.093H4.1a.625.625 0 1 1 0-1.25h.573V4.84zm10.872 1.255H6.016l.996 13.95a.75.75 0 0 0 .748.696h8.527a.75.75 0 0 0 .748-.697l.996-13.95ZM12.65 17.697a.625.625 0 1 1-1.25 0V9.171a.625.625 0 0 1 1.25 0zm2.636.033a.625.625 0 0 1-1.247-.087l.595-8.506a.625.625 0 1 1 1.247.088zm-5.826.58a.625.625 0 0 1-.667-.58l-.595-8.505a.625.625 0 0 1 1.247-.088l.595 8.506a.625.625 0 0 1-.58.667",
        clipRule: "evenodd"
      }
    )
  }
), i = o(e);
export {
  i as Trash,
  i as default
};
